import { j as f, c as g } from "./utils-BdNIfrGQ.js";
import { t as h } from "./BaseTypography.styles-D7he6cFf.js";
import { n as x } from "./normalize-spacing-DY0KSpr_.js";
const d = (t) => {
  const {
    align: r = "left",
    size: a = "lg",
    variant: o,
    fontWeight: i,
    modifier: n,
    truncate: s,
    color: e,
    fontFamily: m,
    spacing: c,
    children: p,
    ...l
  } = t;
  return /* @__PURE__ */ f.jsx(
    "h3",
    {
      className: g(
        h({
          variant: o,
          align: r,
          size: a,
          fontWeight: i,
          modifier: n,
          truncate: s,
          color: e,
          fontFamily: m
        }),
        x(c)
      ),
      ...l,
      children: p
    }
  );
};
export {
  d as H
};
